import React from "react";
import styled from "styled-components";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  color?: string;
  backgroundColor?: string;
  hoverColor?: string;
  hoverBackgroundColor?: string;
  fontSize?: string;
  fullWidth?: boolean;
  onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) &
    (() => any);
}

export const Button = ({
  text,
  color,
  backgroundColor,
  hoverColor,
  hoverBackgroundColor,
  fontSize,
  fullWidth,
  onClick,
  ...props
}: IProps) => {
  return (
    <ButtonContainer
      type="submit"
      color={color || "#FFF"}
      backgroundColor={backgroundColor || "#01A8CE"}
      hoverColor={hoverColor || "#FFF"}
      hoverBackgroundColor={hoverBackgroundColor || "#0190B0"}
      fontSize={fontSize || "14px"}
      fullWidth={fullWidth}
      onClick={onClick}
      {...props}
    >
      {text}
    </ButtonContainer>
  );
};

const ButtonContainer = styled.button<Omit<IProps, "text">>`
  border-radius: 0.5em;
  padding: 1em 1.5em;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  font-size: ${(props) => props.fontSize};
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(1, 168, 206, 0.3);
  }

  &:hover {
    background-color: ${(props) => props.hoverBackgroundColor};
    color: ${(props) => props.hoverColor};
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;

export default Button;